import api from 'Application/api/api';

const deleteInvestor = (signal, id) =>
	api.delete(`/investors/${id}`, {
		signal,
	});

export default deleteInvestor;
